<template>
  <div>
    <OtherHeader :img_header="header_image" header="ตั้งค่าเว็บไซต์อื่นๆ" link_back="managewebsite"/>
    <MenuOther/>
    <Faqs_page/>
  </div>
</template>

<script>
import OtherHeader from "@/components/admin/manage_website/other_setting/menu_other/OtherHeader";
import HeaderImage from "@/assets/faqs.png";
import MenuOther from "@/components/admin/manage_website/other_setting/menu_other/MenuOther";
import Faqs_page from "@/components/admin/manage_website/other_setting/Faqs_page";
export default {
  name: "FaqsPage",
  components: {
    Faqs_page,
    MenuOther,
    OtherHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
